import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=4fe37bd9"
import script from "./payment.vue?vue&type=script&lang=js"
export * from "./payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fe37bd9')) {
      api.createRecord('4fe37bd9', component.options)
    } else {
      api.reload('4fe37bd9', component.options)
    }
    module.hot.accept("./payment.vue?vue&type=template&id=4fe37bd9", function () {
      api.rerender('4fe37bd9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/payment.vue"
export default component.exports